import {
  shouldUseDDMMFormat,
  getDisplayFormat,
  getMomentDisplayFormat
} from 'utils/regionalDateHelper';

const getCurrentCompany = (state) => state.auth.user?.current_company;

export const getCurrentCountryCode = (state) => {
  const company = getCurrentCompany(state);
  return company?.country_code || 'US';
};

export const shouldUseRegionalFormat = (state) => {
  const countryCode = getCurrentCountryCode(state);
  return shouldUseDDMMFormat(countryCode);
};

export const getCurrentDateDisplayFormat = (state) => {
  const countryCode = getCurrentCountryCode(state);
  return getDisplayFormat(countryCode);
};

export const getCurrentMomentFormat = (state) => {
  const countryCode = getCurrentCountryCode(state);
  return getMomentDisplayFormat(countryCode);
};
